import { on } from "events";
import { Check, CircleAlert, View } from "lucide-react";
import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";
import { validateEmail } from "../../uiHelpers";

type AppCustomPropertyShortProps = {
    customProperty: CustomProperty;
    data: any;
    validate: boolean;
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyShort = ({customProperty, data, validate, onChange} : AppCustomPropertyShortProps) => {

    const [value, setValue] = useState<string>(data as string || "");

    useEffect(() => {
        onChange(customProperty.label, value);
    }, [value]);

    return (
        <div className="app-custom-property-short">
            {/* <div className="app-custom-property-label">
                {customProperty.label}
            </div> */}
            <div className="app-custom-property-value"> 
                <input 
                    type="text"
                    value={value}
                    onChange={(event) => {
                        setValue(event.target.value);
                        onChange(customProperty.label, event.target.value);
                    }}
                />
                {validate && !value && customProperty.required &&
                    <div className="app-employee-record-error">
                        <Check size={16} color="red"/>
                    </div>
                } 
            </div>
        </div>
    )
}
